// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:46:09+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            8fec4ad4fe5c5b767d4627a91fe42ccd
//    Signature:      eyJpdiI6IldydTc5RXR5NEx3VzlmaWJaSURUdFE9PSIsInZhbHVlIjoiSHhJbElmMjJuRHRhcCtwOWNuQXlLSDIybzZ6UVN6dllcL2dicm1haXNoRmJsMXl1U29hZHEzano2WmVcL0JHVkxvMDloOE0rc1RWQnhxRnh4dU5ad2FKMUFKNmhTYlhnNUlhNGJ6dTFjN2JFckE3b0xCQW5wMVBzeGFtRWk5bDhhZDlBOTNyT1RQWU9YVEdacGM1ZkRcLzkxaE9QRWd0bFhaTUtycFVsQ2VMRVhNbkdjT2pCM2ZRbjBsXC9LOWpSMUkwd0JoTHdOVkNLSGF4dWRpWlVKdmc1K0pSTEZnWUlsbHVcL0dTQ0kxRHRYUmlPKzk1YjE4XC9HeDdJSlhLdG9DWkp4OVJ5SVFkREdWWWNPUTk5aW9MemUxbHRWZ2tRQjRGK3BaTVhDZjFZRm4yYkVBa3pjVThCTVkrOWlYZW5DeWFJc0tQOVFRSVR1S0x5MXc4T2c5MjZIWFM1b0JjeXl3UnpjZkdNdlwvbWpFMFRpOXlQZ2ZNUUJVZEpIdzYyOTRTSkhUUmFSZHhOZVF2MmJBTmFRNkZaU3h3N2xcL0JtXC9iOGZZb3Q5M3ZZcUJ0b2UwWT0iLCJtYWMiOiJjOTMyYjNmNzVkM2VmZDA4OGQ5ZDhhZWFjMzQzZTNlNTU3MmQ3NzQ5MDg0MzdjYTNkNmMxYzI0ZTgzNmZkOTgwIn0=
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
